var map = {
	"./auditlog.cattle.io.auditpolicy": 53614,
	"./auditlog.cattle.io.auditpolicy.vue": 53614,
	"./catalog.cattle.io.app": 29027,
	"./catalog.cattle.io.app.vue": 29027,
	"./catalog.cattle.io.clusterrepo": 55310,
	"./catalog.cattle.io.clusterrepo.vue": 55310,
	"./compliance.cattle.io.clusterscan": 10356,
	"./compliance.cattle.io.clusterscan.vue": 10356,
	"./ext.cattle.io.kubeconfig": 83935,
	"./ext.cattle.io.kubeconfig.vue": 83935,
	"./fleet.cattle.io.bundle": 46974,
	"./fleet.cattle.io.bundle.vue": 46974,
	"./fleet.cattle.io.cluster": 22632,
	"./fleet.cattle.io.cluster.vue": 22632,
	"./fleet.cattle.io.clustergroup": 84375,
	"./fleet.cattle.io.clustergroup.vue": 84375,
	"./fleet.cattle.io.clusterregistrationtoken": 7408,
	"./fleet.cattle.io.clusterregistrationtoken.vue": 7408,
	"./fleet.cattle.io.gitrepo": 65319,
	"./fleet.cattle.io.gitrepo.vue": 65319,
	"./fleet.cattle.io.helmop": 66497,
	"./fleet.cattle.io.helmop.vue": 66497,
	"./group.principal": 99862,
	"./group.principal.vue": 99862,
	"./harvesterhci.io.management.cluster": 69829,
	"./harvesterhci.io.management.cluster.vue": 69829,
	"./helm.cattle.io.projecthelmchart": 46685,
	"./helm.cattle.io.projecthelmchart.vue": 46685,
	"./logging.banzaicloud.io.clusterflow": 72325,
	"./logging.banzaicloud.io.clusterflow.vue": 72325,
	"./logging.banzaicloud.io.flow": 23376,
	"./logging.banzaicloud.io.flow.vue": 23376,
	"./management.cattle.io.cluster": 21079,
	"./management.cattle.io.cluster.vue": 21079,
	"./management.cattle.io.feature": 80890,
	"./management.cattle.io.feature.vue": 80890,
	"./management.cattle.io.fleetworkspace": 74219,
	"./management.cattle.io.fleetworkspace.vue": 74219,
	"./management.cattle.io.oidcclient": 65339,
	"./management.cattle.io.oidcclient.vue": 65339,
	"./management.cattle.io.podsecurityadmissionconfigurationtemplate": 20261,
	"./management.cattle.io.podsecurityadmissionconfigurationtemplate.vue": 20261,
	"./management.cattle.io.setting": 32312,
	"./management.cattle.io.setting.vue": 32312,
	"./management.cattle.io.user": 7261,
	"./management.cattle.io.user.vue": 7261,
	"./monitoring.coreos.com.alertmanagerconfig": 1208,
	"./monitoring.coreos.com.alertmanagerconfig.vue": 1208,
	"./namespace": 5639,
	"./namespace.vue": 5639,
	"./networking.k8s.io.ingress": 82300,
	"./networking.k8s.io.ingress.vue": 82300,
	"./node": 21590,
	"./node.vue": 21590,
	"./persistentvolume": 27613,
	"./persistentvolume.vue": 27613,
	"./persistentvolumeclaim": 44560,
	"./persistentvolumeclaim.vue": 44560,
	"./projectsecret": 6702,
	"./projectsecret.vue": 6702,
	"./provisioning.cattle.io.cluster": 16794,
	"./provisioning.cattle.io.cluster.vue": 16794,
	"./rbac.authorization.k8s.io.clusterrolebinding": 89113,
	"./rbac.authorization.k8s.io.clusterrolebinding.vue": 89113,
	"./secret": 44932,
	"./secret.vue": 44932,
	"./service": 73671,
	"./service.vue": 73671,
	"./ui.cattle.io.navlink": 92711,
	"./ui.cattle.io.navlink.vue": 92711,
	"./workload": 95423,
	"./workload.vue": 95423
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	var id = map[req];
	return __webpack_require__(id);
});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 78967;
module.exports = webpackAsyncContext;